// extracted by mini-css-extract-plugin
export default {"textArea":"Textarea_textArea__MXTCO"};